import {ErrorHandler, Injectable} from '@angular/core';
import * as Sentry from '@sentry/angular';
import {environment} from '../../../environments/environment';

@Injectable()
export class SentryErrorHandler implements ErrorHandler {
  private sentryHandler = Sentry.createErrorHandler({showDialog: false});

  handleError(error: any): void {
    if (!environment.production) {
      console.error('Error:', error.originalError || error);
    }
    this.sentryHandler.handleError(error);
  }
}
